module.exports = __webpack_public_path__ + "img/48e25c1.jpg";